module.exports = __webpack_public_path__ + "static/media/related_games.018de3dc.png";